import React from 'react';
import { Content } from './Content';
import { BackgroundPage } from '@/components/Layout/BackgroundPage';

export function ResetPassword() {
	return (
		<BackgroundPage>
			<Content />
		</BackgroundPage>
	);
}
